module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/gatsby-plugin-gorgias-al/gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/gatsby-plugin-pinterest-al/gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/gatsby-plugin-bing-ads-al/gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/gatsby-plugin-retention-al/gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-W4FGB3X","includeInDevelopment":true,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
